import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { systemAuditLogApi } from '../../../apis/SystemAuditLogApi/SystemAuditLogApi';
import { IAuditLogMetadata } from '../SystemAuditLog';

export function useAuditLogMetadata(): UseQueryResult<IAuditLogMetadata, Error> {
  return useQuery({
    queryKey: ['auditLogs', 'metadata'],
    queryFn: () => systemAuditLogApi.getAuditLogMetadata(),
    staleTime: 30 * 60 * 1000, // 30 minutes
  });
}
